import { Linkedin } from "lucide-react";

type TeamCardProps = {
  name: string;
  role: string;
  photo?: string;
  linkedin?: string;
  objectPosition?: string;
};

const initialsOf = (full: string) => {
  const parts = full.split(" ").filter(Boolean);
  const a = parts[0]?.[0] ?? "";
  const b = parts[1]?.[0] ?? "";
  return (a + b).toUpperCase();
};

export default function TeamCard({ name, role, photo, linkedin, objectPosition = "center_20%" }: TeamCardProps) {
  return (
    <div className="group overflow-hidden rounded-xl border bg-card shadow-sm transition-all hover:-translate-y-1 hover:shadow-lg hover:border-primary/30">
      <div className="w-full h-80 sm:h-72 overflow-hidden rounded-t-xl">
        {photo ? (
          <img
            src={photo}
            alt={name}
            className="w-full h-full object-cover"
            style={{ objectPosition: objectPosition.replace('_', ' ') }}
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full bg-muted/30 flex items-center justify-center">
            <span className="text-4xl font-bold text-muted-foreground/30">
              {initialsOf(name)}
            </span>
          </div>
        )}
      </div>
      <div className="p-5 text-center">
        <h3 className="text-lg font-semibold tracking-tight">{name}</h3>
        <p className="text-sm text-muted-foreground mt-1">{role}</p>
        {linkedin && (
          <a
            href={linkedin}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`LinkedIn — ${name}`}
            className="inline-flex items-center justify-center mt-3 text-primary hover:text-primary/80 transition-colors"
          >
            <Linkedin className="h-5 w-5" />
          </a>
        )}
      </div>
    </div>
  );
}
